
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateCronFilterForm from '@/services/QA/cron-settings/forms/CreateCronFilterForm';
import TicketRepositoryInterface from '@/services/QC-V2/ticket/interfaces';

@Component({
  inject: [
    'ticketRepositoryV2',
  ],
})
export default class CreateTicketCronConfig extends Vue {
  private form: WPXFormValue<CreateCronFilterForm> = new WPXFormValue(CreateCronFilterForm);
  private ticketRepositoryV2!: TicketRepositoryInterface;
  private loading: boolean = true;

  private properties: Array<{ key: string, value: string }> = [
    { key: 'Client ID', value: 'client_id' },
    { key: 'Client Name', value: 'name' },
    { key: 'Client Email', value: 'email' },
    { key: 'Ticket Status', value: 'status' },
    { key: 'Department', value: 'department' },
  ];

  private created(): void {
    this.loading = false;
  }

  private async createFilter(): Promise<void> {
    try {
      await this.ticketRepositoryV2.createCronFilter({
        property: this.form.data.property,
        value: this.form.data.value,
      });

      this.$successDialog.show('Filter Created Successfully');
      await this.$router.push({ name: 'ticket_cron_config' });
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }
}
